export let ImageResizeOptions = /*#__PURE__*/function (ImageResizeOptions) {
  ImageResizeOptions["crop"] = "CROP";
  ImageResizeOptions["fit"] = "FIT";
  return ImageResizeOptions;
}({});
//# sourceMappingURL=types.js.map